import React, { useEffect, useState } from "react";
import { SellerAccountForm } from "./SellerAccountForm";
import { SellerLoginForm } from "./SellerLoginForm";
import { Alert, Button, Fade, Stack } from "@mui/material";

export const BecomeSeller = () => {
  const [isLogin, setIsLogin] = useState(false);
   const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [localError, setLocalError] = useState<string | null>(null);
  const handleShowPage = () => {
    setIsLogin(!isLogin);
  };
  useEffect(() => { 
    setSuccessMessage(null)
    setLocalError(null)
   },[])
   
  return (
    <div className="grid  md:gap-5 overflow-y-hidden grid-cols-3  relative">
        {localError && (
                <Fade in={!!localError} timeout={{ enter: 700, exit: 700 }}>
                  <Stack
                    sx={{ width: "30%", mb: 2,top:0,right:0,position:"absolute" }}
                    spacing={2}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <Alert
                    
                      severity="error"
                      onClose={() => {
                        setTimeout(() => {
                          setLocalError(null); // Set null after the exit duration (300ms)
                        }, 700); // Match the "exit" timeout value
                      }}
                    >
                      {localError}
                    </Alert>
                  </Stack>
                </Fade>
              )}
               {successMessage && (
          <Fade in={!!successMessage} timeout={{ enter: 700, exit: 700 }}>
            <Stack
              sx={{ width: "30%", mb: 2,top:0,right:0,position:"absolute" }}
              spacing={2}
              display="flex"
              justifyContent="flex-end"
            >
              <Alert
              
                severity="success"
                onClose={() => {
                    setSuccessMessage(null); // Set null after the exit duration (300ms)
                }}
              >
                {successMessage}
              </Alert>
            </Stack>
          </Fade>
        )}
      <section className="lg:col-span-1 md:col-span-2  p-10 col-span-3 shadow-lg rounded-b-md mt-10">
        {!isLogin ? <SellerAccountForm setSuccessMessage={setSuccessMessage}
                setLocalError={setLocalError} /> : <SellerLoginForm setSuccessMessage={setSuccessMessage}
                setLocalError={setLocalError}/>}
        <div className="mt-10 space-y-2 ">
          <h1 className="text-center text-sm font-medium">Have Account</h1>
          <Button
            onClick={handleShowPage}
            fullWidth
            sx={{ py: "11px" }}
            variant="outlined"
          >
            {isLogin ? "Register" : "Login"}
          </Button>
        </div>
      </section>
      <section className="hidden self-center justify-self-center md:col-span-1 lg:col-span-2 lg:flex py-5 ">
        <div className="lg:w-[80%] md:[w-70%] pt-10">
            <div className="space-y-2 font-bold text-center">
                <p className="text-2xl">Join the Marketplace Revolution</p>
                <p className="text-lg text-primary">Boost your sales Today</p>
            </div>
            <img className="w-full" src="https://www.jotform.com/blog/wp-content/uploads/2021/03/how-to-sell-online-featured-1.png" alt="" />
        </div>
      </section>
    </div>
  );
};
